import React from 'react'
import cn from 'comma-number'
import PropTypes from 'prop-types'
import SvgIcon from 'Components/SvgIcon'
import {
  _ListingDetailContainer,
  _Price,
  _MaintFee,
  _UnitInformationContainer,
  _PriceContainer,
  _IconContainer,
  _LeftBlock,
  _RightBlock,
  _Tag,
} from './styles'

const PreconCardDetail = (
  {
    askingPrice,
    baths,
    sqft,
    sqftMax,
    sqftMin,
    propertyType,
    maintFee,
    isFloorplan,
    title,
    bedType,
  }) => {
  const renderIcons = () => (
    <>
      <div>
        <SvgIcon name="#icon-beds" width={15} height={12} />
        <span>
          {/* {beds || '-'}&nbsp; */}
          {bedType !== 'Studio' ? `${bedType || '-'} bed` : 'Studio'}
        </span>
      </div>
      <div>
        <SvgIcon name="#icon-bath" width={12} height={12} />
        <span>{baths || '-'}&nbsp;bath</span>
      </div>
      <div>
        <SvgIcon name="#icon-size" width={12} height={12} />
        <span>
          {sqft || ((sqftMax && sqftMin) ? `${sqftMin} - ${sqftMax}` : '-')}&nbsp;sqft
        </span>
      </div>
    </>
  )
  const isAskingPriceAvailable = Number.isFinite(askingPrice) && askingPrice > 0
  const isMaintFeeAvailable = Math.round(maintFee) > 0
  return (
    <_ListingDetailContainer>
      <_LeftBlock>
        <_UnitInformationContainer>
          {isFloorplan ? `${title || '-'}` : `Unit ${title || '-'}`}
        </_UnitInformationContainer>
        <_IconContainer>
          {renderIcons()}
        </_IconContainer>
      </_LeftBlock>
      <_RightBlock>
        <_PriceContainer>
          <_MaintFee>
            {isMaintFeeAvailable ? `Maint Fees. $${cn(Math.round(maintFee))}/mo` : ''}
          </_MaintFee>
          <_Price>{isAskingPriceAvailable ? `${isFloorplan ? 'From ' : ''}$${cn(askingPrice)}` : 'Contact for pricing'}</_Price>
        </_PriceContainer>
        <_Tag>{propertyType || 'Floorplan/ Unit'}</_Tag>
      </_RightBlock>
    </_ListingDetailContainer>
  )
}

PreconCardDetail.propTypes = {
  listing: PropTypes.shape({}),
  askingPrice: PropTypes.string,
  baths: PropTypes.number,
  sqft: PropTypes.number,
  sqftMax: PropTypes.number,
  sqftMin: PropTypes.number,
  propertyType: PropTypes.string,
  maintFee: PropTypes.number,
  isFloorplan: PropTypes.bool,
  title: PropTypes.string,
  bedType: PropTypes.string,
}

export default PreconCardDetail

